import React, { useState, useEffect, useRef } from "react";
import style from "./NewFilter.module.css";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    MenuItem,
    Button,
    IconButton,
    Select,
    FormControl,
    InputLabel,
} from "@material-ui/core";
import {
    COMPARE_VALUES,
    COMPARE_STRINGS_ARR,
    NAMES_FIELDS,
    STATUSES,
    ORDER_SOURCE,
    SEARCH_FIELDS_DEFAULT,
} from "../../lib/data";
import moment from "moment";
import axios from "axios";

// ищем вариант равенства
const findConditionOperator = (str) => {
    let foundCondition;
    if (str) {
        foundCondition = COMPARE_VALUES.find((condition) => {
            const operator = Object.values(condition)[0];
            return str.startsWith(operator);
        });
    }

    return foundCondition || COMPARE_VALUES[0];
};

// отдает строки без равенства
const clearCompare = (str) => {
    const date = str?.split(":") ?? null;

    if (date) {
        if (COMPARE_STRINGS_ARR.includes(`${date[0]}:`)) return date[1];
        else return str;
    } else return str;
};

// смена равенства
const changeCompare = (curCompareVal, setCompareVal) => {
    const curCompareIndex = COMPARE_VALUES.findIndex(
        (elem) =>
            elem[Object.keys(curCompareVal)[0]] ===
            curCompareVal[Object.keys(curCompareVal)[0]],
    );

    let nextElIndex = curCompareIndex + 1;

    if (curCompareIndex === COMPARE_VALUES.length - 1) {
        nextElIndex = 0;
    }

    setCompareVal(COMPARE_VALUES[nextElIndex]);
};

// Очищаем для заполнения попапа
const getCommonFields = (data) => {
    const commonKeys = Object.keys(NAMES_FIELDS).filter((key) =>
        removeEmptyValues(data).hasOwnProperty(key),
    );

    const commonFields = commonKeys.reduce((result, key) => {
        result[key] = data[key];
        return result;
    }, {});
    return Object.keys(commonFields);
};

const NewFilter = (props) => {
    const [showInput, setShowInput] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [inputWidth, setInputWidth] = useState(200);
    const inputRef = useRef(null);
    const searchRef = useRef(null);
    const [openPopup, setOpenPopup] = useState(false);
    const [visiblePopupElements, setVisiblePopupElements] = useState([]);
    const [availableFields, setAvailableFields] = useState([]);
    const [selectedField, setSelectedField] = useState(null);
    const [deletedField, setDeletedField] = useState(null);
    const [nameSearch, setNameSearch] = useState("");
    const [savedSearches, setSavedSearches] = useState(
        JSON.parse(localStorage.getItem(`new_search_named_${props.hotelId}`)) ||
            [],
    );
    const [globalData, setGlobalData] = useState(
        props.globalSearch.search.reservations_new,
    );

    const [compareCreated, setCompareCreated] = useState(
        findConditionOperator(globalData.created_at),
    );
    const [compareStart, setCompareStart] = useState(
        findConditionOperator(globalData.date_in),
    );
    const [compareEnd, setCompareEnd] = useState(
        findConditionOperator(globalData.date_out),
    );
    const [compareTotal, setCompareTotal] = useState(
        findConditionOperator(globalData.total),
    );

    useEffect(() => {
        props.initSearch(removeEmptyValues(globalData));
    }, []);

    useEffect(() => {
        setCompareCreated(findConditionOperator(globalData.created_at));
        setCompareStart(findConditionOperator(globalData.date_in));
        setCompareEnd(findConditionOperator(globalData.date_out));
        setCompareTotal(findConditionOperator(globalData.total));

        props.updateGlobalSearch(globalData, "reservations_new");
    }, [globalData]);

    // ловим клавиатуру и вставку
    useEffect(() => {
        document.addEventListener("paste", handlePaste);
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("paste", handlePaste);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    const handleKeyDown = (event) => {
        if (!event.ctrlKey) setShowInput(true);
    };

    const handlePaste = (event) => {
        navigator.clipboard.readText().then((text) => {
            setInputValue(text);
            setShowInput(true);
        });
    };

    useEffect(() => {
        if (openPopup && searchRef.current) {
            searchRef.current.focus();
        }
    }, [openPopup]);

    useEffect(() => {
        if (showInput && inputRef.current) {
            inputRef.current.focus();
        }
    }, [showInput]);

    // регулируемая длина строки
    useEffect(() => {
        const inputLength = +inputValue.length * 10;
        setInputWidth((pr) => {
            if (inputLength > 200) return inputLength;
            else return 200;
        });
    }, [inputValue]);

    useEffect(() => {
        handleChangeGlobal("created_at", clearCompare(globalData.created_at));
    }, [compareCreated]);

    useEffect(() => {
        handleChangeGlobal("date_in", clearCompare(globalData.date_in));
    }, [compareStart]);

    useEffect(() => {
        handleChangeGlobal("date_out", clearCompare(globalData.date_out));
    }, [compareEnd]);

    useEffect(() => {
        handleChangeGlobal("total", clearCompare(globalData.total));
    }, [compareTotal]);

    const handleChangeInput = (event) => {
        setInputValue(event.target.value);
    };

    const handleChangeGlobal = (field, value) => {
        let result = value;

        if (isDate(value) || value === "текдата") {
            if (field === "created_at")
                result = Object.values(compareCreated)[0] + value;
            else if (field === "date_in")
                result = Object.values(compareStart)[0] + value;
            else if (field === "date_out")
                result = Object.values(compareEnd)[0] + value;
            else if (field === "total")
                result = Object.values(compareTotal)[0] + value;
        }

        const updated = {
            ...globalData,
            [field]: result,
        };

        setGlobalData(updated);
        // props.updateGlobalSearch(updated, 'reservations_new')
    };

    const handleClear = () => {
        setInputValue("");
        setVisiblePopupElements([]);
        setNameSearch("");
        props.initSearch(
            removeEmptyValues(SEARCH_FIELDS_DEFAULT.reservations_new),
        );
        setGlobalData(SEARCH_FIELDS_DEFAULT.reservations_new);
        // props.updateGlobalSearch(SEARCH_FIELDS_DEFAULT.reservations_new, 'reservations_new')
    };

    const handleSaveSearch = () => {
        if (nameSearch.trim() === "") {
            alert("Вы не ввели имя");
            return;
        }
        const saved =
            JSON.parse(
                localStorage.getItem(`new_search_named_${props.hotelId}`),
            ) || [];

        const existingSearchIndex = saved.findIndex(
            (search) => search.name === nameSearch.trim(),
        );

        if (existingSearchIndex !== -1) {
            saved[existingSearchIndex].searchData = globalData;
        } else {
            const newSearch = {
                name: nameSearch.trim(),
                searchData: globalData,
            };
            saved.push(newSearch);
        }

        localStorage.setItem(
            `new_search_named_${props.hotelId}`,
            JSON.stringify(saved),
        );
        setSavedSearches(saved);
    };

    const handleDeleteSearch = (name) => {
        const saved =
            JSON.parse(
                localStorage.getItem(`new_search_named_${props.hotelId}`),
            ) || [];

        const indexToDelete = saved.findIndex((search) => search.name === name);
        if (indexToDelete !== -1) {
            saved.splice(indexToDelete, 1);
            setSavedSearches(saved);
            localStorage.setItem(
                `new_search_named_${props.hotelId}`,
                JSON.stringify(saved),
            );
        } else {
            alert(`Поисковый запрос ${name} не найден.`);
        }
    };

    const handleLoadSearch = (search) => {
        setVisiblePopupElements(getCommonFields(search.searchData));
        setGlobalData(search.searchData);
        setNameSearch(search.name);
        setOpenPopup(true);
    };

    const handleColdSearch = () => {
        props.setLoading(true);
        axios
            .post(`/manager/data/reservations/cold_search/${props.hotelId}`, {
                str: inputValue,
            })
            .then((response) => {
                if (response.data?.search) {
                    const searchData = {
                        ...SEARCH_FIELDS_DEFAULT.reservations_new,
                    };
                    const responseData = response.data.search.searchData;

                    Object.keys(responseData).forEach((key) => {
                        if (searchData.hasOwnProperty(key)) {
                            searchData[key] = responseData[key];
                        }
                    });

                    response.data.search.searchData = searchData;

                    handleLoadSearch(response.data.search);
                } else {
                    handleClear();
                    setOpenPopup(true);
                }
                if (response.data?.attention) {
                    alert(response.data?.attention);
                }
            });

        setOpenPopup(true);
    };

    const handleSearch = () => {
        props.initSearch(removeEmptyValues(globalData));
        setOpenPopup(false);
    };

    useEffect(() => {
        setVisiblePopupElements(getCommonFields(globalData));
    }, []);

    useEffect(() => {
        setAvailableFields(
            Object.keys(NAMES_FIELDS).filter(
                (field) => !visiblePopupElements.includes(field),
            ),
        );
    }, [visiblePopupElements]);

    // добавление поля
    useEffect(() => {
        if (selectedField) {
            setVisiblePopupElements((prevElements) => [
                ...prevElements,
                selectedField,
            ]);
            setSelectedField(null);
        }
    }, [selectedField]);

    // Удаляем из видимых и очищаем в глобальном
    useEffect(() => {
        if (deletedField) {
            setVisiblePopupElements((prevElements) =>
                prevElements.filter((field) => field !== deletedField),
            );
            const updated = {
                ...globalData,
                [deletedField]: "",
            };
            setGlobalData(updated);

            // props.updateGlobalSearch(updated, 'reservations_new')
            setDeletedField(null);
        }
    }, [deletedField]);

    const createCompare = (field) => {
        let compareVal, setCompareVal;

        if (field === "created_at") {
            compareVal = compareCreated;
            setCompareVal = setCompareCreated;
        } else if (field === "date_in") {
            compareVal = compareStart;
            setCompareVal = setCompareStart;
        } else if (field === "date_out") {
            compareVal = compareEnd;
            setCompareVal = setCompareEnd;
        } else if (field === "total") {
            compareVal = compareTotal;
            setCompareVal = setCompareTotal;
        }

        return (
            <IconButton
                key={`compare_${field}`}
                title={compareVal.title}
                style={{ padding: "0 15px 0 10px" }}
                onClick={() => {
                    changeCompare(compareVal, setCompareVal);
                }}
            >
                {Object.keys(compareVal)[0]}
            </IconButton>
        );
    };

    return (
        <>
            <div className={style.savedSearchesContainer}>
                <h3>Сохраненные поисковые запросы:</h3>
                {savedSearches.map((search, index) => (
                    <div
                        key={`${index}_${search.name}`}
                        className={style.savedSearchesField}
                    >
                        <div
                            className={style.buttonLoadSavedSearch}
                            onClick={() => handleLoadSearch(search)}
                        >
                            {search.name}
                        </div>
                        <button
                            onClick={() => handleDeleteSearch(search.name)}
                            className={`${style.clearButton} ${style.aroundSavedSearches}`}
                        >
                            ✕
                        </button>
                    </div>
                ))}
            </div>
            <div
                key={"searchInputContainerNewFilter"}
                className={style.searchInputContainer}
            >
                {showInput && (
                    <>
                        <button
                            onClick={handleClear}
                            className={`${style.clearButton} ${style.aroundInputButtons}`}
                            title="Очистить и выполнить поиск по умолчанию"
                        >
                            ✕
                        </button>
                        <button
                            onClick={handleColdSearch}
                            className={`${style.searchButton} ${style.aroundInputButtons}`}
                            title="Выполнить предварительный поиск"
                        >
                            ✔
                        </button>
                        <input
                            style={{ width: `${inputWidth}px` }}
                            type="text"
                            placeholder="Введите запрос"
                            value={inputValue}
                            key={"searchInputNewFilter"}
                            id={"searchInputNewFilter"}
                            onChange={handleChangeInput}
                            ref={inputRef}
                            onPaste={handlePaste}
                            className={style.searchInput}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") handleColdSearch();
                            }}
                        />
                        <button
                            onClick={() => setOpenPopup(true)}
                            className={`${style.searchEditButton} ${style.aroundInputButtons}`}
                            title="Редактировать текущий поиск"
                        >
                            ✎
                        </button>
                    </>
                )}

                <Dialog
                    open={openPopup}
                    onClose={() => setOpenPopup(false)}
                    maxWidth="xl"
                    onKeyDown={(event) => {
                        if (event.key === "Enter") handleSearch();
                    }}
                >
                    <DialogTitle>Настройки поиска</DialogTitle>
                    <DialogContent>
                        <div
                            className={style.containerSearch}
                            key={"containerSearch"}
                        >
                            <div
                                key={`container_visible_save_search`}
                                className={`${style.containerVisible} ${style.containerVisibleSearch}`}
                            >
                                <button
                                    onClick={handleSaveSearch}
                                    className={`${style.searchButton} ${style.aroundSaveSearch}`}
                                >
                                    save
                                </button>
                                <TextField
                                    type="text"
                                    value={nameSearch}
                                    onChange={(e) =>
                                        setNameSearch(e.target.value)
                                    }
                                    label={"Имя поиска"}
                                />
                            </div>

                            {visiblePopupElements.length > 0 &&
                                visiblePopupElements.map((field, idx) => {
                                    const variantOptions =
                                        field === "room_type_id"
                                            ? props.roomTypes
                                            : field === "order_source"
                                              ? ORDER_SOURCE
                                              : STATUSES;
                                    return [
                                        "room_type_id",
                                        "status",
                                        "order_source",
                                    ].includes(field) &&
                                        props?.roomTypes?.length > 0 ? (
                                        <div
                                            key={`container_visible_${field}`}
                                            className={style.containerVisible}
                                        >
                                            <FormControl
                                                fullWidth
                                                margin="normal"
                                            >
                                                <InputLabel>
                                                    {NAMES_FIELDS[field]}
                                                </InputLabel>
                                                <Select
                                                    multiple
                                                    value={clearCompare(
                                                        globalData[field],
                                                    ).split(",")}
                                                    onChange={(e) => {
                                                        const selectedValues =
                                                            e.target.value
                                                                .map((v) =>
                                                                    v.toString(),
                                                                )
                                                                .filter(
                                                                    (f) =>
                                                                        f !==
                                                                        "",
                                                                );
                                                        const currentValues =
                                                            clearCompare(
                                                                globalData[
                                                                    field
                                                                ],
                                                            ).split(",");
                                                        const updatedValues =
                                                            currentValues.includes(
                                                                selectedValues[
                                                                    +selectedValues.length -
                                                                        1
                                                                ],
                                                            )
                                                                ? currentValues.filter(
                                                                      (value) =>
                                                                          value !==
                                                                          selectedValues[
                                                                              +selectedValues.length -
                                                                                  1
                                                                          ],
                                                                  )
                                                                : [
                                                                      ...selectedValues,
                                                                  ];
                                                        if (
                                                            field ===
                                                            "room_type_id"
                                                        )
                                                            handleChangeGlobal(
                                                                field,
                                                                updatedValues.join(
                                                                    ",",
                                                                ),
                                                            );
                                                        else
                                                            handleChangeGlobal(
                                                                field,
                                                                selectedValues.join(
                                                                    ",",
                                                                ),
                                                            );
                                                    }}
                                                    inputProps={{
                                                        name: `multiselect-${field}`,
                                                    }}
                                                >
                                                    {variantOptions.map(
                                                        (el) => (
                                                            <MenuItem
                                                                key={
                                                                    el.id +
                                                                    field
                                                                }
                                                                value={el.id}
                                                            >
                                                                {el.name}
                                                            </MenuItem>
                                                        ),
                                                    )}
                                                </Select>
                                            </FormControl>
                                            <button
                                                key={`button_visible_${field}`}
                                                onClick={() =>
                                                    setDeletedField(field)
                                                }
                                                className={`${style.clearButton} ${style.aroundInputButtons} ${style.deleteButtons}`}
                                            >
                                                ✕
                                            </button>
                                        </div>
                                    ) : (
                                        <div
                                            key={`container_visible_${field}`}
                                            className={style.containerVisible}
                                        >
                                            {[
                                                "created_at",
                                                "date_in",
                                                "date_out",
                                                "total",
                                            ].includes(field) &&
                                                createCompare(field)}
                                            <TextField
                                                key={`visible_${field}`}
                                                label={NAMES_FIELDS[field]}
                                                value={clearCompare(
                                                    globalData[field],
                                                )}
                                                onChange={(e) =>
                                                    handleChangeGlobal(
                                                        field,
                                                        e.target.value,
                                                    )
                                                }
                                                fullWidth
                                                margin="normal"
                                                ref={
                                                    idx === 0
                                                        ? searchRef
                                                        : undefined
                                                }
                                                error={
                                                    [
                                                        "created_at",
                                                        "date_in",
                                                        "date_out",
                                                    ].includes(field)
                                                        ? clearCompare(
                                                              globalData[field],
                                                          ) !== "текдата"
                                                            ? !isDate(
                                                                  clearCompare(
                                                                      globalData[
                                                                          field
                                                                      ],
                                                                  ),
                                                              )
                                                            : false
                                                        : false
                                                }
                                                helperText={
                                                    [
                                                        "created_at",
                                                        "date_in",
                                                        "date_out",
                                                    ].includes(field) &&
                                                    !isDate(
                                                        clearCompare(
                                                            globalData[field],
                                                        ),
                                                    ) &&
                                                    clearCompare(
                                                        globalData[field],
                                                    ) !== "текдата" &&
                                                    "Неверный формат даты"
                                                }
                                            />
                                            {[
                                                "created_at",
                                                "date_in",
                                                "date_out",
                                            ].includes(field) && (
                                                <input
                                                    type="date"
                                                    value={
                                                        isDate(
                                                            clearCompare(
                                                                globalData[
                                                                    field
                                                                ],
                                                            ),
                                                        )
                                                            ? clearCompare(
                                                                  globalData[
                                                                      field
                                                                  ],
                                                              )
                                                            : ""
                                                    }
                                                    onChange={(e) =>
                                                        handleChangeGlobal(
                                                            field,
                                                            e.target.value,
                                                        )
                                                    }
                                                    className={style.DateInput}
                                                />
                                            )}
                                            <button
                                                key={`button_visible_${field}`}
                                                onClick={() =>
                                                    setDeletedField(field)
                                                }
                                                className={`${style.clearButton} ${style.aroundInputButtons} ${style.deleteButtons}`}
                                            >
                                                ✕
                                            </button>
                                        </div>
                                    );
                                })}
                        </div>

                        {availableFields.length > 0 && (
                            <TextField
                                select
                                label="Доступные поля"
                                value=""
                                onChange={(e) =>
                                    setSelectedField(e.target.value)
                                }
                                fullWidth
                                margin="normal"
                            >
                                <MenuItem value="" disabled>
                                    Выберите поле
                                </MenuItem>
                                {availableFields.map((field) => (
                                    <MenuItem key={field} value={field}>
                                        {NAMES_FIELDS[field]}
                                    </MenuItem>
                                ))}
                            </TextField>
                        )}

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSearch}
                        >
                            Применить
                        </Button>
                    </DialogContent>
                </Dialog>
            </div>
        </>
    );
};

export default NewFilter;

const removeEmptyValues = (obj) => {
    const result = {};
    for (const key in obj) {
        if (obj[key] !== "") {
            result[key] = obj[key];
        }
    }
    return result;
};

const isDate = (value) => !isNaN(Date.parse(value));
